<template>
  <div ref="appContent" class="app-content">
    <el-card>
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
      >
        <el-form-item label="合同编号：">
          <el-input v-model="dataForm.code" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="客户：">
          <customer
            v-model="dataForm.customerId"
            @change="reload"
            :clearable="true"
          ></customer>
        </el-form-item>
        <el-form-item label="交付日期：">
          <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">{{
            $t("query")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:agreement:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >添加合同</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @row-click="rowClickHandle"
        :highlight-current-row="true"
        :max-height="maxTableHeight"
      >
        <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="合同编号"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="showDetailDialog(scope.row)">
              {{ scope.row.code }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="总金额"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            {{ moneyFormat(scope.row.totalAmount) }}{{ scope.row.currency }}
          </template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creatorName"
          label="操作记录"
          header-align="center"
          width="220"
        >
          <template slot-scope="scope">
            <div>操作人：{{ scope.row.creatorName }}</div>
            <div>操作时间：{{ scope.row.createDate }}</div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('handle')"
          header-align="center"
          align="center"
          width="260"
        >
          <template slot-scope="scope">
            <div class="flex flex-wrap justify-center">
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </el-card>
    <el-card>
      <div slot="header" class="card-header">
        <div>合同明细</div>
      </div>
      <DetailList
        :parentId="currentId"
        ref="detailList"
        :maxTableHeight="maxTableHeight"
      ></DetailList>
    </el-card>
    <DetailDialog ref="detailDialog"></DetailDialog>
  </div>
</template>

<script>
import DetailDialog from "./detail-dialog";
import DetailList from "./detail-list.vue";
import mixinViewModule from "@/mixins/view-module";
import BigNumber from "bignumber.js";
import qs from 'qs'
import Cookies from 'js-cookie'

export default {
  mixins: [mixinViewModule],
  components: { DetailList, DetailDialog },
  data() {
    return {
      dateArr: [],
      currentId: "",
      statusType: {
        10: "",
        20: "warning",
        30: "success",
      },
      mixinViewModuleOptions: {
        getDataListURL: "/trade/agreement/page",
        getDataListIsPage: true,
      },
      dataForm: {
        code: "",
        customerId: "",
        beginDate: "",
        endDate: "",
      },
      maxTableHeight: 100,
    };
  },
  activated() {
    this.$nextTick(() => {
      this.maxTableHeight =
        (this.$refs.appContent.clientHeight -
          this.$refs.queryForm.$el.clientHeight -
          20) /
        2;
    });
  },
  watch: {
    dateArr(newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0];
        this.dataForm.endDate = newVal[1];
      } else {
        this.dataForm.beginDate = "";
        this.dataForm.endDate = "";
      }
      this.currentId = "";
      this.reload();
    },
  },
  methods: {
    beforeTableBinding(dataList) {
      if (dataList && dataList.length > 0) {
        this.currentId = dataList[0].id;
      } else {
        this.currentId = "";
      }
    },
    addOrUpdateHandle(row) {
      let id = "";
      if (row) {
        id = row.id;
      }
      this.$router.push(`/trade/order/save?id=${id}`);
    },
    showDetailDialog(row) {
      this.$refs.detailDialog.id = row.id;
      this.$refs.detailDialog.init();
    },
    rowClickHandle(row) {
      this.currentId = row ? row.id : "";
      this.$refs.detailList.getDataList();
    },
  },
};
</script>
